import { render } from "./SearchExercisesFilterVertical.vue?vue&type=template&id=03d9bba8&scoped=true"
import script from "./SearchExercisesFilterVertical.vue?vue&type=script&lang=js"
export * from "./SearchExercisesFilterVertical.vue?vue&type=script&lang=js"

import "./SearchExercisesFilterVertical.vue?vue&type=style&index=0&id=03d9bba8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d9bba8"]])

export default __exports__